module.exports = __webpack_public_path__ + "static/media/Akemi_6542.d78aa858.jpg";